import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import { router } from './router'
import { initSeo } from '@/composables/useSeo'
import { initAnalytics } from '@/composables/useAnalytics'
import './assets/styles/main.css'

initSeo()
void initAnalytics()

const app = createApp(App)

app.use(createPinia())
app.use(router)

app.mount('#app')
